export const MOMENCE_HOST_ID = 279063;
export const MOMENCE_TOKEN = "94c4be2d71";
export const MOMENCE_API_BASE = "https://momence.com/_api/primary/api/v1";
export const MOMENCE_STUDIO_TIMEZONE = "America/Chicago";
export const MOMENCE_EMBED_URL = "https://momence.com/YoQIga/Hot-Yoga/137239955";
export const MOMENCE_EMBED_HTML = null;
export const MOMENCE_SCHEDULE_URL = "https://momence.com/YoQIga/Hot-Yoga/137239955";
